import { render } from "./AddExtractionTemplate.vue?vue&type=template&id=48f0baf1&scoped=true"
import script from "./AddExtractionTemplate.vue?vue&type=script&lang=js"
export * from "./AddExtractionTemplate.vue?vue&type=script&lang=js"

import "./AddExtractionTemplate.vue?vue&type=style&index=0&id=48f0baf1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f0baf1"]])

export default __exports__